import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col,Button,Input,Label,FormGroup,Form } from 'reactstrap';
import Config from '../../Core/Config.js';
import { framework } from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import { libs, ui } from 'saffroncodejs';
var PageManager = framework.PageManager;

class OmrEnferadi extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.showElhaghie=this.showElhaghie.bind(this);
        this.setEndorsement = this.setEndorsement.bind(this);
     
        this.state = {
            EndorsementV:'1',
            isLoading: true,
            activeTab: 1,
            data: { "CodeMelli": "2142596347", "BId": 1358323, "FullBNo": "96/04/700/8055/4001559", "SodurDate": "1396/02/30", "LastBNo": null, "AgentText": "شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055", "BimeGozarText": "علي ولائي کد 2599583 به نفع بانک صنعت و معدن  شعبه ساري", "CodMelliOrEconomic": "2142596347", "BimegozarAddress": "استان ‏مازندران‏،شهر آمل-شهرک صنعتي امامزاده عبداله- فاز1- کارگاه توليدي آقاي ولايي", "BimegozarTel": "01222523538", "BimeKindText": "صنعتي", "ActivityKindText": "‏چراغ روشنايى خيابان ـ توليد‏", "ActivitySharh": "توليد چراغ روشنايي گاز", "AddressText": "استان ‏مازندران‏،شهر آمل ، شهرک صنعتي امامزاده عبداله- فاز1- کارگاه توليدي آقاي ولايي", "Moddat": 365, "BeginDate": "1396/03/01", "EndDate": "1397/03/01", "AllRiskText": " آتش سوزي ، صاعقه ، انفجار ، زلزله و آتشفشان ، سيل و طغيان آب ، طوفان و گردباد و تندباد ، ضايعات ذوب برف و آب باران ، ريزش سقف ناشي ازسنگيني برف ، تركيدگي لوله آب ، انفجار ظروف تحت فشار صنعتي ، دفرمه شدن ظروف تحت فشار", "MarhunatSarmaye": 1024000000, "MarhunatHbStr": "883,650 ريال", "HBStr": "883,650 ريال", "SumSarmayeStr": "1,024,000,000 ريال", "SAAMPercent": "%9", "MaliatAvarez": "79,529 ريال", "HBWithAvarezStr": "963,179 ريال", "Reshte": 1, "Endorsement": [], "Mavared": [{ "ShahrdariAvarezNerkh": 3, "AfzoodeMaliatNerkh": 6, "BId": 1358323, "ElhNo": 0, "GId": 349, "MoredeBimeText": null, "MavaredTitr": "عبارت است از اموال متعلق به بيمه گذار و مورد تاييد کارشناس محترم بانک صنعت و معدن طبق نامه شماره 2148/م/الف مورخ 1396/02/26مادامي که در نشاني مورد بيمه نگهداري و يا مورد استفاده قرار گيرد به شرح ذيل :", "BNo": "96/04/700/8055/4001559", "SodurText": "شعبه ساري کد 700", "AgentText": "شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055", "LastBNo": null, "PishnahadDate": "1396/02/16", "SodurDate": "1396/02/30", "SumSarmaye": 1024000000, "SumSarmayeStr": "يك ميليارد و بيست و چهار ميليون", "HB": 883650, "HBText": "هشتصد و هشتاد و سه هزار و ششصد و پنجاه", "MoneyUnitText": "ريال", "Sharh": "ساختمان توليد ، اداري  با مساحت تقريبي 366  مترمربع  به  انضمام کليه تاسيسات مربوطه جمعا\" به ارزش", "Sarmaye": "253,000,000", "MaxCommitment": "253,000,000", "Nerkh": "0.75", "MHB": "126,500", "Radif": "1", "InnerOrder": 1 }, { "ShahrdariAvarezNerkh": 3, "AfzoodeMaliatNerkh": 6, "BId": 1358323, "ElhNo": 0, "GId": 349, "MoredeBimeText": null, "MavaredTitr": "عبارت است از اموال متعلق به بيمه گذار و مورد تاييد کارشناس محترم بانک صنعت و معدن طبق نامه شماره 2148/م/الف مورخ 1396/02/26مادامي که در نشاني مورد بيمه نگهداري و يا مورد استفاده قرار گيرد به شرح ذيل :", "BNo": "96/04/700/8055/4001559", "SodurText": "شعبه ساري کد 700", "AgentText": "شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055", "LastBNo": null, "PishnahadDate": "1396/02/16", "SodurDate": "1396/02/30", "SumSarmaye": 1024000000, "SumSarmayeStr": "يك ميليارد و بيست و چهار ميليون", "HB": 883650, "HBText": "هشتصد و هشتاد و سه هزار و ششصد و پنجاه", "MoneyUnitText": "ريال", "Sharh": "ماشين آلات  و تجهيزات طبق ليست پيوست نامه شماره 2148/م/الف بانک صنعت و معدن ساري جمعا\" به ارزش", "Sarmaye": "771,000,000", "MaxCommitment": "771,000,000", "Nerkh": "0.9", "MHB": "385,500", "Radif": "2", "InnerOrder": 1 }], "Bill": [], "PishnahadNo": null, "PishnahadDate": "1396/02/16", "ElhNo": 0, "ErrorMessage": null },
            returndataelhaghieha:'',
        }
        this.state.data = {};

        this.state.btns = [];

        this.loadDetail();

    }

    encodeSodurId(encodedId) {
        return encodedId;
    }

    componentWillReceiveProps(props) {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail() {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/lf/api/lfS/PolicyInfo",

                { id: this.currentSodurId, codeMelli: UserManager.MelliCode() }
            ),
            BimeManager.header())
            .then((result) => {
                this.setState({ data: result.data, isLoading: false })//
            })
            .catch((error) => { alert(error) })
    }


    showElhaghie()
    {
       
        switch (this.state.EndorsementV) {
            
            case '1':
            this.setState({
                returndataelhaghieha:
                <Row>
                    {this.state.data.FowtElh.map((foot) =>
                        <div className="border-List">
                        <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{foot.BId}</Col>
                       <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{foot.ElhNo}</Col>
                       <Col sm="12"><span className="bold-head">نوع الحاقیه:</span>{foot.ChangeKindText}</Col>
                       <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{foot.FullBno}</Col>
                       <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{foot.ElhSodurDate}</Col>
                       <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{foot.ActiveDate}</Col>
                       <Col sm="12"><span className="bold-head">تاريخ درخواست:</span>{foot.BNPishnahadDate}</Col>
                       <Col sm="12"><span className="bold-head">مدت بیمه نامه (سال):</span>{foot.Period}</Col>
                       <Col sm="12"><span className="bold-head">بیمه گذار:</span>{foot.BimeGozarText}</Col>
                       <Col sm="12"><span className="bold-head">معرف:</span>{foot.AgentText}</Col>
                       <Col sm="12"><span className="bold-head">تعداد اقساط حق بيمه دريافت شده:</span>{foot.NumberOfGhestPaid}</Col>
                       <Col sm="12"><span className="bold-head">تاريخ آخرين قسط دريافت شده:</span>{foot.LastPaidSrdDate}</Col>
                       <Col sm="12"><span className="bold-head">روش پرداخت حق بيمه:</span>{foot.PayPeriodText}</Col>
                       <Col sm="12"><span className="bold-head">تاریخ فوت:</span>{foot.ActiveDate}</Col>
                       <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{foot.PayPeriodChangeSharh}</Col>
                       <Col sm="12"><span className="bold-head">شماره وام:</span>{foot.Fowt.LoanNo}</Col>
                       <Col sm="12"><span className="bold-head">مانده وام:</span>{libs.StringFunctions.currancyPrint(foot.Fowt.RtnLoan)+('ریال')}</Col>
                       <Col sm="12"><span className="bold-head">جريمه ديرکرد اقساط وام:</span>{foot.Fowt.LoanJarime}</Col>
                       <Col sm="12"><span className="bold-head">علت فوت:</span>{foot.Fowt.DieCause}</Col>
                       <Col sm="12"><span className="bold-head">سرمايه مخفف:</span>{libs.StringFunctions.currancyPrint(foot.Fowt.PV)+('ریال')}</Col>
                       <Col sm="12"><span className="bold-head">سرمايه بيمه عمر زماني:</span>{libs.StringFunctions.currancyPrint(foot.Fowt.OmreZamaniCapital)+('ریال')}</Col>
                       <Col sm="12"><span className="bold-head">سرمايه فوت به علت حادثه:</span>{libs.StringFunctions.currancyPrint(foot.Fowt.HdsDieCapital)+('ریال')}</Col>
                       <Col sm="12"><span className="bold-head">اندوخته:</span>{libs.StringFunctions.currancyPrint(foot.Fowt.V)+('ریال')}</Col>
                       <Col sm="12"><span className="bold-head">مشارکت در منافع:</span>{foot.Fowt.Profit}</Col>
                       <Col sm="12"><span className="bold-head">جبران اندوخته کسر می گردد :</span>{foot.Fowt.GhestDirkardJarime}</Col>
                       <Col sm="12"><span className="bold-head">اقساط بيمه نامه وصولي برگشتي:</span>{foot.Fowt.BargashtiVslGhest}</Col>
                       <Col sm="12"><span className="bold-head">مانده حق بيمه سال فوت:</span>{libs.StringFunctions.currancyPrint(foot.Fowt.FowtYearPrmNotRemained)+('ریال')}</Col>
                       <Col sm="12"><span className="bold-head">مبلغ اقساط بيمه نامه لاوصول:</span>{libs.StringFunctions.currancyPrint(foot.Fowt.NotVslGhest)+('ریال')}</Col>
                       <Col sm="12"><span className="bold-head">سرمايه قابل پرداخت:</span>{libs.StringFunctions.currancyPrint(foot.Fowt.PayableCapital)+('ریال')}</Col>
                                 <br />
                        </div>
    
                    )}
                         
                </Row>
             })
             break;
            

        case '2':
        this.setState({
            returndataelhaghieha:
            <Row>
                {this.state.data.DefaultElh.map((mofad) =>
                    <div className="border-List">
                        <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه</span>{mofad.BId}</Col>
                        <Col sm="12"><span className="bold-head">نوع بیمه:</span>{mofad.Bimekind}</Col>
                        <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{mofad.ElhNo}</Col>
                        <Col sm="12"><span className="bold-head">نوع الحاقیه :</span>{mofad.ChangeKindText}</Col>
                        <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{mofad.FullBno}</Col>
                        <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{mofad.ElhSodurDate}</Col>
                        <Col sm="12"><span className="bold-head">تاريخ درخواست:</span>{mofad.PishnahadDate}</Col>
                        <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{mofad.ActiveDate}</Col>
                        <Col sm="12"><span className="bold-head">تاريخ شروع بيمه نامه:</span>{mofad.BeginDate}</Col>
                        <Col sm="12"><span className="bold-head">تاريخ انقضاء بيمه نامه:</span>{mofad.EndDate}</Col>
                        <Col sm="12"><span className="bold-head">بیمه گذار:</span>{mofad.BimeGozarText}</Col>
                        <Col sm="12"><span className="bold-head">معرف:</span>{mofad.AgentText}</Col>
                        <Col sm="12"><span className="bold-head">تعداد اقساط حق بيمه دريافت شده:</span>{mofad.NumberOfGhestPaid}</Col>
                        <Col sm="12"><span className="bold-head">تاريخ آخرين قسط دريافت شده:</span>{mofad.LastPaidSrdDate}</Col>
                        <Col sm="12"><span className="bold-head">روش پرداخت حق بيمه:</span>{mofad.PayPeriodText}</Col>
                        <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{mofad.Sharh}</Col>
                        <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{mofad.PayPeriodChangeSharh}</Col>
                                                         
                        <br />
                    </div>

                )}
                     
            </Row>
         })
          

        break;

        case '3':
        this.setState({
            returndataelhaghieha:
            <Row>
                {this.state.data.DefaultElh.map((bargasht) =>
                    <div className="border-List">
                      <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه</span>{bargasht.BId}</Col>
                      <Col sm="12"><span className="bold-head">نوع بیمه:</span>{bargasht.Bimekind}</Col>
                      <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{bargasht.ElhNo}</Col>
                      <Col sm="12"><span className="bold-head">نوع الحاقیه :</span>{bargasht.ChangeKindText}</Col>
                      <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{bargasht.FullBno}</Col>
                      <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{bargasht.ElhSodurDate}</Col>
                      <Col sm="12"><span className="bold-head">تاريخ درخواست:</span>{bargasht.PishnahadDate}</Col>
                      <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{bargasht.ActiveDate}</Col>
                      <Col sm="12"><span className="bold-head">تاريخ شروع بيمه نامه:</span>{bargasht.BeginDate}</Col>
                      <Col sm="12"><span className="bold-head">تاريخ انقضاء بيمه نامه:</span>{bargasht.EndDate}</Col>
                      <Col sm="12"><span className="bold-head">بیمه گذار:</span>{bargasht.BimeGozarText}</Col>
                      <Col sm="12"><span className="bold-head">معرف:</span>{bargasht.AgentText}</Col>
                      <Col sm="12"><span className="bold-head">تعداد اقساط حق بيمه دريافت شده:</span>{bargasht.NumberOfGhestPaid}</Col>
                      <Col sm="12"><span className="bold-head">تاريخ آخرين قسط دريافت شده:</span>{bargasht.LastPaidSrdDate}</Col>
                      <Col sm="12"><span className="bold-head">روش پرداخت حق بيمه:</span>{bargasht.PayPeriodText}</Col>
                      <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{bargasht.Sharh}</Col>
                      <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{bargasht.PayPeriodChangeSharh}</Col>
          
                             <br />
                    </div>

                )}
                     
            </Row>
         })
         break;
       
         case '4':
         this.setState({
             returndataelhaghieha:
             <Row>
                 {this.state.data.DefaultElh.map((eslah) =>
                     <div className="border-List">
                 <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه</span>{eslah.BId}</Col>
                 <Col sm="12"><span className="bold-head">نوع بیمه:</span>{eslah.Bimekind}</Col>
                 <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{eslah.ElhNo}</Col>
                 <Col sm="12"><span className="bold-head">نوع الحاقیه :</span>{eslah.ChangeKindText}</Col>
                 <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{eslah.FullBno}</Col>
                 <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{eslah.ElhSodurDate}</Col>
                 <Col sm="12"><span className="bold-head">تاريخ درخواست:</span>{eslah.PishnahadDate}</Col>
                 <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{eslah.ActiveDate}</Col>
                 <Col sm="12"><span className="bold-head">تاريخ شروع بيمه نامه:</span>{eslah.BeginDate}</Col>
                 <Col sm="12"><span className="bold-head">تاريخ انقضاء بيمه نامه:</span>{eslah.EndDate}</Col>
                 <Col sm="12"><span className="bold-head">بیمه گذار:</span>{eslah.BimeGozarText}</Col>
                 <Col sm="12"><span className="bold-head">معرف:</span>{eslah.AgentText}</Col>
                 <Col sm="12"><span className="bold-head">تعداد اقساط حق بيمه دريافت شده:</span>{eslah.NumberOfGhestPaid}</Col>
                 <Col sm="12"><span className="bold-head">تاريخ آخرين قسط دريافت شده:</span>{eslah.LastPaidSrdDate}</Col>
                 <Col sm="12"><span className="bold-head">روش پرداخت حق بيمه:</span>{eslah.PayPeriodText}</Col>
                 <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{eslah.Sharh}</Col>
                 <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{eslah.PayPeriodChangeSharh}</Col>
                         <br />
                     </div>
 
                 )}
                      
             </Row>
          })
          break;


          case '5':
               this.setState({
                   returndataelhaghieha:
                   <Row>
                       {this.state.data.FaskhElh.map((Faskhh) =>
                           <div className="border-List">
                           <Col sm="12"><span className="bold-head">شماره پیشنهاد:</span>{Faskhh.BId}</Col>
                          <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{Faskhh.ElhNo}</Col>
                          <Col sm="12"><span className="bold-head">نوع الحاقیه:</span>{Faskhh.ChangeKindText}</Col>
                          <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{Faskhh.FullBno}</Col>
                          <Col sm="12"><span className="bold-head">تاریخ صدور بیمه نامه:</span>{Faskhh.BNSodurDate}</Col>
                          <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{Faskhh.ElhSodurDate}</Col>
                          <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{Faskhh.ActiveDate}</Col>
                          <Col sm="12"><span className="bold-head">مدت بیمه نامه (سال):</span>{Faskhh.Period}</Col>
                          <Col sm="12"><span className="bold-head">بیمه گذار:</span>{Faskhh.BimeGozarText}</Col>
                          <Col sm="12"><span className="bold-head">معرف:</span>{Faskhh.AgentText}</Col>
                          <Col sm="12"><span className="bold-head">تعداد اقساط حق بيمه دريافت شده:</span>{Faskhh.NumberOfGhestPaid}</Col>
                          <Col sm="12"><span className="bold-head">تاريخ آخرين قسط دريافت شده:</span>{Faskhh.LastPaidSrdDate}</Col>
                          <Col sm="12"><span className="bold-head">علت فسخ شدن:</span>{Faskhh.Kholase}</Col>
                          <Col sm="12"><span className="bold-head">روش پرداخت حق بيمه:</span>{Faskhh.PayPeriodText}</Col>
                          <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{Faskhh.Sharh}</Col>
                          <Col sm="12"><span className="bold-head">تعداد اقساط حق بيمه دريافت نشده:</span>{Faskhh.FaskhElh_NotPaidSrdDate.NotPaidSrdDate}</Col>
                          <Col sm="12"><span className="bold-head">جمع مبلغ پرداخت نشده:</span>{Faskhh.FaskhElh_NotPaidPrm.NotPaidPrm}</Col>
                           <br />
                           </div>
       
                       )}
                            
                   </Row>
                })
                break;



        case '6':
        this.setState({
            returndataelhaghieha:
            <Row>
                {this.state.data.EbtalElh.map((ebtal) =>
                    <div className="border-List">
                     <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{ebtal.ElhNo}</Col>
                     <Col sm="12"><span className="bold-head">نوع الحاقیه:</span>{ebtal.ChangeKindText}</Col>
                     <Col sm="12"><span className="bold-head">نوع بیمه:</span>{ebtal.Bimekind}</Col>
                     <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{ebtal.FullBno}</Col>
                     <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{ebtal.ElhSodurDate}</Col>
                     <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{ebtal.ActiveDate}</Col>
                     <Col sm="12"><span className="bold-head">تاریخ درخواست:</span>{ebtal.BNPishnahadDate}</Col>
                     <Col sm="12"><span className="bold-head">تاریخ شروع بیمه نامه:</span>{ebtal.BeginDate}</Col>
                     <Col sm="12"><span className="bold-head">تاریخ انقضاء بیمه نامه:</span>{ebtal.BNEndDate}</Col>
                     <Col sm="12"><span className="bold-head">مدت بیمه نامه (سال):</span>{ebtal.Period}</Col>
                     <Col sm="12"><span className="bold-head">بیمه گذار:</span>{ebtal.BimeGozarText}</Col>
                     <Col sm="12"><span className="bold-head">معرف:</span>{ebtal.AgentText}</Col>
                     <Col sm="12"><span className="bold-head">تعداد اقساط حق بیمه دریافت شده:</span>{ebtal.NumberOfGhestPaid}</Col>
                     <Col sm="12"><span className="bold-head">تاریخ آخرین قسط دریافت شده:</span>{ebtal.LastPaidSrdDate}</Col>
                     <Col sm="12"><span className="bold-head">روش پرداخت حق بیمه:</span>{ebtal.PayPeriodText}</Col>
                             <br />
                    </div>

                )}
                     
            </Row>
         })

         break;
         case '7':
         this.setState({
             returndataelhaghieha:
             <Row>
                 {this.state.data.AgentChangeElh.map((taghirmoaref) =>
                     <div className="border-List">
                      <Col sm="12"><span className="bold-head">شماره پیشنهاد:</span>{taghirmoaref.BId}</Col>
                      <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{taghirmoaref.ElhNo}</Col>
                      <Col sm="12"><span className="bold-head">نوع الحاقیه:</span>{taghirmoaref.ChangeKindText}</Col>
                      <Col sm="12"><span className="bold-head">نوع بیمه:</span>{taghirmoaref.Bimekind}</Col>
                      <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{taghirmoaref.FullBno}</Col>
                      <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{taghirmoaref.ElhSodurDate}</Col>
                      <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{taghirmoaref.ActiveDate}</Col>
                      <Col sm="12"><span className="bold-head">تاریخ شروع بیمه نامه:</span>{taghirmoaref.BeginDate}</Col>
                      <Col sm="12"><span className="bold-head">تاریخ انقضاء بیمه نامه:</span>{taghirmoaref.BNEndDate}</Col>
                      <Col sm="12"><span className="bold-head">تاريخ در خواست:</span>{taghirmoaref.BNPishnahadDate}</Col>
                      <Col sm="12"><span className="bold-head">بیمه گذار:</span>{taghirmoaref.BimeGozarText}</Col>
                      <Col sm="12"><span className="bold-head">معرف:</span>{taghirmoaref.AgentText}</Col>
                      <Col sm="12"><span className="bold-head">تعداد اقساط حق بیمه دریافت شده:</span>{taghirmoaref.NumberOfGhestPaid}</Col>
                      <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{taghirmoaref.Sharh}</Col>
                      <Col sm="12"><span className="bold-head">معرف قدیم:</span>{taghirmoaref.LastAgent.LastAgent}</Col>
                              <br />
                     </div>
 
                 )}
                      
             </Row>
          })
          break;
         
           case '8':
           this.setState({
               returndataelhaghieha:
               <Row>
                   {this.state.data.ZinafChangeElh.map((zinafelh) =>
                       <div className="border-List">
                      
                         <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{zinafelh.ElhNo}</Col>
                         <Col sm="12"><span className="bold-head">نوع الحاقیه :</span>{zinafelh.ChangeKindText}</Col>
                         <Col sm="12"><span className="bold-head">نوع بیمه:</span>{zinafelh.Bimekind}</Col>
                         <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{zinafelh.FullBno}</Col>
                         <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{zinafelh.ElhSodurDate}</Col>
                         <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{zinafelh.ActiveDate}</Col>
                         <Col sm="12"><span className="bold-head">تاريخ درخواست:</span>{zinafelh.BNPishnahadDate}</Col>
                         <Col sm="12"><span className="bold-head">تاريخ شروع بيمه نامه:</span>{zinafelh.BeginDate}</Col>
                         <Col sm="12"><span className="bold-head">تاريخ انقضاء بيمه نامه:</span>{zinafelh.BNEndDate}</Col>
                         <Col sm="12"><span className="bold-head">بیمه گذار:</span>{zinafelh.BimeGozarText}</Col>
                         <Col sm="12"><span className="bold-head">معرف:</span>{zinafelh.AgentText}</Col>
                         <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{zinafelh.Sharh}</Col>
                         <Col sm="12"><span className="bold-head">نام و نام خانوادگی:</span>{zinafelh.Zinaf.ZinafText}</Col>
                         <Col sm="12"><span className="bold-head">نام پدر:</span>{zinafelh.Zinaf.FatherName}</Col>
                        
                                <br />
                       </div>
   
                   )}
                        
               </Row>
            })
            break;

             case '9':
             this.setState({
                 returndataelhaghieha:
                 <Row>
                     {this.state.data.DefaultElh.map((faskh) =>
                         <div className="border-List">
                         <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه</span>{faskh.BId}</Col>
                        <Col sm="12"><span className="bold-head">نوع بیمه:</span>{faskh.Bimekind}</Col>
                        <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{faskh.ElhNo}</Col>
                        <Col sm="12"><span className="bold-head">نوع الحاقیه :</span>{faskh.ChangeKindText}</Col>
                        <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{faskh.FullBno}</Col>
                        <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{faskh.ElhSodurDate}</Col>
                        <Col sm="12"><span className="bold-head">تاريخ درخواست:</span>{faskh.PishnahadDate}</Col>
                        <Col sm="12"><span className="bold-head">تاریخ موثرالحاقیه:</span>{faskh.ActiveDate}</Col>
                        <Col sm="12"><span className="bold-head">تاريخ شروع بيمه نامه:</span>{faskh.BeginDate}</Col>
                        <Col sm="12"><span className="bold-head">تاريخ انقضاء بيمه نامه:</span>{faskh.EndDate}</Col>
                        <Col sm="12"><span className="bold-head">بیمه گذار:</span>{faskh.BimeGozarText}</Col>
                        <Col sm="12"><span className="bold-head">معرف:</span>{faskh.AgentText}</Col>
                        <Col sm="12"><span className="bold-head">تعداد اقساط حق بيمه دريافت شده:</span>{faskh.NumberOfGhestPaid}</Col>
                        <Col sm="12"><span className="bold-head">تاريخ آخرين قسط دريافت شده:</span>{faskh.LastPaidSrdDate}</Col>
                        <Col sm="12"><span className="bold-head">روش پرداخت حق بيمه:</span>{faskh.PayPeriodText}</Col>
                        <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{faskh.Sharh}</Col>
                        <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{faskh.PayPeriodChangeSharh}</Col>
                      
                                  <br />
                         </div>
     
                     )}
                          
                 </Row>
              })
              break;
        default:
        alert('محتوای رشته مورد نظر موجود نمی باشد')

        
                                    }
                                    }
                                    setEndorsement(event){
                                        this.setState({EndorsementV:event.target.value});
                                        
                                      }

    pagechange(bid,reshte) {

        PageManager.changePage(Config.p_pardakhtman, [bid,reshte]);
    }
    render() {
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>عمرانفرادی</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({ activeTab: 1 }) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>

                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({ activeTab: 2 }) }}>
                            استفاده کنندگان در صورت فوت بیمه شده
                        </NavLink>
                    </NavItem>

                     <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 3 }}
                            onClick={() => { this.setState({ activeTab: 3 }) }}>
                           الحاقیه ها
                        </NavLink>
                    </NavItem>

                    <NavItem>
                        <NavLink onClick={() => { this.pagechange(this.currentSodurId,this.state.data.Reshte) }}>
                            پرداخت شده ها
                        </NavLink>
                    </NavItem>
                </Nav>


                {(!this.state.isLoading) ? (
                    <Form >

                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId={1}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{this.state.data.FullBNo}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{this.state.data.BNSodurDate}</Col>
                                            <Col sm="12"><span className="bold-head">مدت بیمه:</span>{this.state.data.Period}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ شروع ساعت 24 روز:</span>{this.state.data.BeginDate}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ انقضاء ساعت 24 روز:</span>{this.state.data.EndDate}</Col>
                                            <Col sm="12"><span className="bold-head">نام و نام خانوادگی بیمه گذار:</span>{this.state.data.BimeGozarText}</Col>
                                            <Col sm="12"><span className="bold-head">کد ملی بیمه گذار:</span>{this.state.data.BGCodeMelli}</Col>
                                            <Col sm="12"><span className="bold-head">محل صدور بیمه گذار:</span>{this.state.data.BGSodurPlace}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ تولد بیمه گذار:</span>{this.state.data.BGBirthDate}</Col>
                                            <Col sm="12"><span className="bold-head">آدرس بیمه گذار:</span>{this.state.data.BGAddress}</Col>
                                            <Col sm="12"><span className="bold-head">تلفن بیمه گذار:</span>{this.state.data.BGTel}</Col>
                                            <Col sm="12"><span className="bold-head">نام و نام خانوادگی بیمه شده:</span>{this.state.data.Bimeshode}</Col>
                                            <Col sm="12"><span className="bold-head">شماره شناسنامه بیمه شده:</span>{this.state.data.BSIdentityNo}</Col>
                                            <Col sm="12"><span className="bold-head">محل صدور بیمه شده:</span>{this.state.data.BSSodurPlace}</Col>
                                            <Col sm="12"><span className="bold-head">تاریخ تولد بیمه شده:</span>{this.state.data.BSBirthDate}</Col>
                                            <Col sm="12"><span className="bold-head">شغل بیمه شده:</span>{this.state.data.BSJobText}</Col>
                                            <Col sm="12"><span className="bold-head">حق بیمه سالانه:</span>{libs.StringFunctions.currancyPrint(this.state.data.FirstYearMainPrm) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">ترتیب پرداخت حق بیمه:</span>{this.state.data.PayPeriodText}</Col>
                                            <Col sm="12"><span className="bold-head">حق بیمه:</span>{libs.StringFunctions.currancyPrint(this.state.data.FirstGhestPrm) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">سرمایه بیمه در صورت فوت بیمه شده در طول مدت بیمه:</span>{libs.StringFunctions.currancyPrint(this.state.data.FirstCapital) + ('ریال')}</Col>
                                            <Col sm="12"><span className="bold-head">سرمایه بیمه در صورت فوت بیمه شده بر اثر حادثه:</span>{libs.StringFunctions.currancyPrint(this.state.data.HdsDieCapital) + ('ریال')}</Col>

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={2}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">

                                        {
                                            //alert('bill***'+this.state.data.Bill)
                                            (this.state.data.lifeSReciver) ? this.state.data.lifeSReciver.map((estefadekonande) => {
                                                return <span><Row>
                                                    <Col sm="12"><span className="bold-head">نام و نام خانوادگی:</span>{estefadekonande.ZinafText}</Col>
                                                    <Col sm="12"><span className="bold-head">شماره شناسنامه:</span>{estefadekonande.IdentityNo}</Col>
                                                    <Col sm="12"><span className="bold-head">نام پدر:</span>{estefadekonande.FatherName}</Col>

                                                    <Col sm="12"><span className="bold-head">نسبت با بیمه شده:</span>{estefadekonande.ZinafNesbatText}</Col>
                                                    <Col sm="12"><span className="bold-head">درصد:</span>{estefadekonande.DieCapitalPercent}</Col>

                                                    <br />
                                                </Row>
                                                    <hr />
                                                </span>

                                            }) : ''
                                        }


                                    </div>
                                </Col>
                            </Row>
                        </TabPane>


                        <TabPane tabId={3}>

                            <div className="container">
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                    <Label for="exampleNumber" className="LeftToRight" sm={2}>الحاقیه ها</Label>
                                    <Col sm={8}>
                                        <Input type="select" name="select1" id="elhaghie" onChange={this.setEndorsement}>
                                            <option>انتخاب کنید</option>
                                            <option value={'1'}>الحاقیه فوت</option>
                                            <option value={'2'}>تغییر در مفاد بیمه نامه</option>
                                            <option value={'3'}>برگشت بيمه نامه به حالت جاري</option>
                                            <option value={'4'}>اصلاح مشخصات بیمه گذار</option>
                                            <option value={'5'}>فسخ</option>
                                            <option value={'6'}>ابطال بيمه نامه-برگشت كل حق بيمه بيمه نامه</option>
                                            <option value={'7'}>تغيير معرف</option>
                                            <option value={'8'}>تغيير ذينفع</option>
                                            <option value={'9'}>فسخ از طرف بيمه گذار_كسرحق بيمه به صورت كوتاه مدت</option>
                                        </Input>
                                    </Col>
                                    <Button onClick={this.showElhaghie}> نمایش</Button>
                                </FormGroup>

                                <Row>
                                    <Col sm="12">
                                        <div className="container ListOfList">
                                            {this.state.returndataelhaghieha}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </TabPane>


                    </TabContent>
                    </Form>
                    ) : (<ui.Preloader />)



                }
            </div>
        );
    }
}


export default OmrEnferadi;


// WEBPACK FOOTER //
// ./src/components/ListCollapse/OmrEnferadi.js